<template>
  <v-card>
    <v-data-table :headers="headers" :items="stockList" :footer-props="{
      'items-per-page-options': [5, 10, 15, 20],
    }" :items-per-page.sync="itemsPerPage" :page.sync="page" :server-items-length="stockCount" :loading="stockLoading"
      loading-text="Loading... Please wait" class="elevation-0">
      <template v-slot:top>
        <v-text-field v-model="searchInput" class="mx-4" append-icon="mdi-magnify"></v-text-field>
      </template>
      <template v-slot:item="row">
        <tr>
          <td>{{ row.item.barcode }}</td>
          <td>{{ row.item.stock_code }}</td>
          <td>{{ row.item.display_product_name }}</td>
          <td>{{ row.item.brand_name }}</td>
          <td>{{ row.item.unit }}</td>
          <td>₱ {{ formatMoney(row.item.retail) }}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="authPermissions.has('stocks:edit')" class="mx-2" fab dark small v-bind="attrs" v-on="on"
                  color="yellow" @click="editStock(row.item)">
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit Stock</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
import { moneyMixin } from './../../mixins/helper.mixins'
import stockRepository from '@/repositories/stock.repository'
import { apiVars } from '@/extra-functions/api-helper.extra'
import { errorHandler } from '@/extra-functions/store.extra'
import searchDelay from '@/extra-functions/searchDelay.extra'

const fetchDelay = searchDelay()

function tableVars() {
  return {
    ...apiVars('stock'),

    headers: [
      { text: 'Barcode', value: 'barcode' },
      {
        text: 'Stock Code',
        align: 'start',
        sortable: false,
        value: 'id',
      },
      { text: 'Product', value: 'product_name' },
      { text: 'Brand', value: 'brand_name' },
      { text: 'Unit', value: 'unit' },
      { text: 'Retail Price', value: 'retail' },
      { text: 'Config' },
    ],
    stockCount: 0,
    itemsPerPage: 5,
    page: 1,
  }
}

export default {
  name: 'vIndexStock',
  data() {
    return {
      ...tableVars(),
      searchInput: null,
    }
  },
  created() {
    this.refreshData()
  },
  computed: {
    ...mapState({
      stockUpdated: state => state.stock.channelUpdate,
      storeId: state => state.settings.storeId,
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  watch: {
    searchInput(val) {
      this.page = 1
      this.refreshData()
    },
    itemsPerPage(val) {
      this.stockLoading = true
      fetchDelay(() => { this.fetchCurrentPage() })
    },
    page(val) {
      this.stockLoading = true
      fetchDelay(() => { this.fetchCurrentPage() })
    },
    stockUpdated() {
      this.refreshData()
    },
  },
  methods: {
    // ...mapActions({
    // fetch: 'stock/fetch',
    // fetchDataCount: 'stock/fetchDataCount',
    // }),
    editStock(stockData) {
      this.$emit('editStock', stockData)
    },
    fetchCurrentPage() {
      const index = (this.page - 1) * this.itemsPerPage
      const limit = this.itemsPerPage
      const search = this.searchInput
      stockRepository.storeList(this.storeId, { index, limit, search })
        .then(({ data }) => { this.stockList = data })
        .catch(e => { this.stockErrors = errorHandler(e) })
        .then(() => { this.stockLoading = false })
    },
    fetchDataCount() {
      const search = this.searchInput
      stockRepository.storeCount(this.storeId, { search })
        .then(({ data }) => { this.stockCount = data })
    },
    refreshData() {
      this.stockLoading = true
      fetchDelay(() => {
        this.fetchDataCount()
        this.fetchCurrentPage()
      })
    },
  },
  mixins: [
    moneyMixin,
  ],
}
</script>
